import { Flex, Link, Text, useColorMode } from "@chakra-ui/react";

const Footer = () => {
  const { colorMode } = useColorMode();

  return (
    <Flex
      width="full"
      align="center"
      alignSelf="flex-end"
      justifyContent="center"
      borderTop="1px solid"
      borderTopColor={colorMode === "dark" ? "gray.700" : "gray.200"}
      bg={colorMode === "dark" ? "gray.800" : "white"}
      color={colorMode === "dark" ? "gray.400" : "inherit"}
      p={"15px"}
    >
      {/*TODO change the copyright thing*/}
      <Text fontSize="xs">
        Copyright &copy; {new Date().getFullYear()} by{" "}
        <Link
          href="https://www.avodah.dev"
          isExternal
          color={colorMode === "dark" ? "brand.sage_green" : "brand.primary"}
        >
          Org
        </Link>
      </Text>
    </Flex>
  );
};

export default Footer;
